<template>
  <banner :rounded="true" :showImage="false">
    <div class="flex text-white gap-6 md:gap-14">
      <circle-progress-bar
        :completionPercentage="applicationCompletionPercentage"
      ></circle-progress-bar>
      <div class="grid gap-1">
        <p class="font-semibold text-base">Incomplete Application</p>
        <p class="text-sm">
          Please complete the application and get Rs 500 reward points
        </p>
        <router-link
          :to="{ name: 'Signup' }"
          class="btn btn--normal w-full  font-semibold btn--white justify-self-start"
        >
          Continue
        </router-link>
      </div>
    </div>
  </banner>
</template>
<script>
import { mapGetters } from 'vuex';
import Banner from './Banner.vue';
import CircleProgressBar from './CircleProgressBar.vue';

export default {
  name: 'IncompleteApplicationCard',
  components: {
    Banner,
    CircleProgressBar,
  },
  computed: {
    ...mapGetters(['applicationCompletionPercentage']),
  },
};
</script>
